import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useQuery, useMutation } from '@apollo/react-hooks';
import Card from './Card';
import Input, { PhoneNumberInput } from './Input';
import { GET_CURRENT_USER, UPDATE_USER_INFO } from '../graphql/queries';
import Button from './Button';
import Loader from './Loader';

const LoaderContainer = styled.div`
  position: absolute;
  top: calc(50vh - 60px);
  left: calc(50vw - 60px);
`;

const Form = styled.form`
width: 60%;

@media (max-width:991px){
  width: 100%;
}
`;

export default function UserProfile() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const { data, loading } = useQuery(GET_CURRENT_USER);
  const [updateUserInfo, { loading: updateLoading }] = useMutation(UPDATE_USER_INFO, {
    variables: {
      email,
      firstName,
      lastName,
      phoneNumber,
    },
    onError(error) {
      console.log(error);
    },
    onCompleted(data) {
      console.log(data);
    },
  });

  useEffect(() => {
    if (data && data.getCurrentUser) {
      setFirstName(data.getCurrentUser.firstName);
      setLastName(data.getCurrentUser.lastName);
      setEmail(data.getCurrentUser.email);
      setPhoneNumber(data.getCurrentUser.phoneNumber);
    }
  }, [data]);

  if (loading) {
    return (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    );
  }

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        updateUserInfo();
      }}
    >
      <Card width="100%" padding="20px 30px">
        <Input
          width="100%"
          top
          type="text"
          header="FIRST NAME"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          required
        />
        <Input
          width="100%"
          type="text"
          header="LAST NAME"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          required
        />
        <Input
          width="100%"
          type="email"
          header="EMAIL"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <PhoneNumberInput
          width="100%"
          type="tel"
          header="PHONE NUMBER"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          required
        />
      </Card>
      <Button
        margin="40px 30px"
        text="UPDATE USER PROFILE"
        type="submit"
        width="fit-content"
        loading={updateLoading}
      />
    </Form>
  );
}
